/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
//material
import Icon from 'material/graphic/icon/icon';
import Link from 'material/ctas/link/link';
//utils
import { exportMetricsExcelFile } from 'utils/downloadFiles';
import { transpileTableBody } from 'utils/data_visualization_transpilers';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/exportexcel/exportexcel_styles';



/* ========== ~~~~~~~~~~ LINK : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ExportExcel = (props) => {

    const handleExport = () => !props.export.data.length ? props.displayErrorMessage('Sorry, no data to export.') : exportMetricsExcelFile(props.export.fileName, props.export.data, props.export.excludedColumns);

    const handleExportAll = () => {
       const { requestAllDetailData, paramString, fileName, excludedColumns } = props.exportAll;
       requestAllDetailData(paramString)
           .then(response => {
               //this is the same if statement that is used when setting no data state for charts
               if(!response.data || !response.data.total || !response.data.total.aggregate) {
                   props.displayErrorMessage('Sorry, no data to export.');
               }else{
                   exportMetricsExcelFile(fileName, transpileTableBody(response.data), excludedColumns)
               }

           }).catch(err=> console.log(err) || props.displayErrorMessage('There was a problem fetching your data.'))
   };

    return (
        <div className={`exportexcel all-${!!props.exportAll}`} >
            <Link type={`action`} text={props.exportAll ? `Export All` : `Export Current`}
                  color={`primary`}
                  action={props.exportAll ? handleExportAll : handleExport}
                  icon={<Icon name={`arrow-circle-down`} />}
                  iconRight
            />
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ExportExcel);